import React from 'react';
import DOMPurify from 'isomorphic-dompurify';
import { makeStyles } from '@material-ui/core/styles';
const sanitizer = DOMPurify.sanitize;

const useStyles = makeStyles(() => ({
	color: {
		color: '#706D75'
	}
}));

export const CardBenefit = ({ srcImage, title, paragraph, paragraph2 }) => {
	const classes = useStyles();

	return (
		<div
			className={`rounded border border-gray-300 mb-14 mx-2 md:mx-4 px-10 py-8 flex flex-col md:min-h-700p`}
		>
			<div className="mb-6 w-full font-poppins">
				<span className={`flex justify-between`}>
					<img
						src={srcImage}
						alt={`Icono de ${title}`}
						className="h-16 w-auto px-2 py-2"
					/>
				</span>
			</div>
			<div className="text-2xl sm:text-4xl leading-none font-bold font-poppins mb-6 text-purple-500">
				{title}
			</div>
			<div
				className={`${classes.color}  text-base font-light leading-relaxed font-poppins`}
				dangerouslySetInnerHTML={{ __html: sanitizer(paragraph) }}
			/>
			{paragraph2 && (
				<p
					className={`${classes.color} text-base font-light leading-relaxed font-poppins`}
				>
					{paragraph2}
				</p>
			)}
		</div>
	);
};

export default CardBenefit;
